import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("er_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export async function fetchContent() {
  const { data } = await axios.get(`${API}/content`);
  return data;
}

export const waLink = (settings, msg) => {
  const num = (settings && settings.whatsapp) || "50487465034";
  return `https://wa.me/${num}${msg ? `?text=${encodeURIComponent(msg)}` : ""}`;
};

export const telLink = (settings) => `tel:${(settings && settings.phone) || "+50487465034"}`;

export function formatApiError(detail) {
  if (detail == null) return "Ocurrió un error. Intenta de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
